import { Component, OnInit } from '@angular/core';
import { ManageService } from '../service/manage.service';
import { Servers } from '../constants/servers';
import { Ribbon } from '../constants/ribbon';
import { Roles } from '../constants/roles';

@Component({
    selector: 'app-manage-modal',
    templateUrl: './manage-modal.component.html',
    styleUrl: './manage-modal.component.css',
    standalone: false
})

export class ManageModalComponent implements OnInit{
  public allServers: boolean = false;
  private servers = Servers;

  public ribbon = Ribbon;
  public roles = Roles;

  constructor(
    public manageService: ManageService){ }

  ngOnInit(): void {
    const availableServers = this.manageService.getAvailableServers();
    if(availableServers.length <= 0){
      this.allServers = true;
    }
  }

  onChangeAllServers(){
    this.allServers = !this.allServers;
    if(this.allServers){
      this.manageService.selectedServers = this.servers.map(server => server.value);
    }else{
      this.manageService.selectedServers = [];
    }
  }

  onChangeKeepAfterDelay(){
    this.manageService.keepAfterDelay = !this.manageService.keepAfterDelay;
  }
}
